export default __webpack_public_path__ + "static/media/slider1.1437bc79.jpg";